<template>
  <div class="items">
    <el-row
      class="item"
      v-for="(item, idx) in 4"
      :key="'x' + idx"
      :gutter="30"
      :class="idx % 2 == 0 ? 'odd' : ''"
    >
      <el-col class="left" :span="8">
        <div class="title">Bench</div>
        <div class="subtitle">SPACE DIVISION</div>
        <div class="desc">
          Improvised dialogue does not mean that there is something. There needs
          to be a configuration that encourages it to happen. Such workplaces
          encourage people to share knowledge and solve problems creatively.
        </div>
      </el-col>
      <el-col class="right" :span="16">
        <el-image
          src="//cdn.weappdev.cn/wp-content/uploads/sites/77/2022/08/im.png"
          lazy
        />
      </el-col>
    </el-row>
    <!--  -->
  </div>
</template>
<script>
export default {
  name: "OverView",
};
</script>
<style lang="scss" scoped>
.items {
  .item {
    display: flex;

    align-items: center;
    font-family: "Roboto";
    font-style: normal;
    font-weight: 700;
    margin-bottom: 200px;

    &.odd {
      flex-direction: row-reverse;
    }

    .left {
      display: flex;
      flex-direction: column;

      .title {
        font-size: 50px;
        line-height: 59px;
      }

      .desc {
        margin-top: 100px;
        font-weight: 400;
        font-size: 18px;
        line-height: 21px;
      }

      .subtitle {
        margin-top: 40px;
        font-size: 25px;
        line-height: 29px;
      }
    }

    .right {
      img {
        width: 100%;
        // width: 977px;
        // height: 652px;
      }
    }
  }
}
</style>
